// eslint-disable-next-line import/no-unresolved
import { produce } from 'immer';

import { ENROLLMENT_DECLINED } from 'actions/enrollmentDeclined';
import { ENROLLMENT_PENDING } from 'actions/enrollmentPending';
import { ENROLLMENT_SUCCESSFUL } from 'actions/enrollmentSuccessful';
import { LOADER_DISPLAYED } from 'actions/loaderDisplayed';
import { LOADER_HIDDEN } from 'actions/loaderHidden';

import { pageLoaderTypes } from 'consts/pageLoaderTypeConsts';

/** pageLoaderTypes.DEFAULT = { name: 'default', animationLength: 0 } */
export const initialState = {
  loaderType: pageLoaderTypes.DEFAULT,
  isDisplayed: true,
};

const pageLoaderReducer = (state = initialState, action) =>
  produce(state, draft => {
    const { payload, type } = action;

    switch (type) {
      case LOADER_DISPLAYED:
        draft.loaderType =
          selectPayloadLoaderType(payload) || pageLoaderTypes.DEFAULT;
        draft.isDisplayed = true;
        break;
      case LOADER_HIDDEN:
        draft.isDisplayed = false;
        break;
      case ENROLLMENT_PENDING:
        draft.isDisplayed = false;
        break;
      case ENROLLMENT_DECLINED:
        draft.isDisplayed = false;
        break;
      case ENROLLMENT_SUCCESSFUL:
        draft.isDisplayed = false;
        break;
    }
  });

export default pageLoaderReducer;

const selectPayloadLoaderType = payload => payload && payload.loaderType;
